import { createReducer } from "@reduxjs/toolkit";
import { AuthorizationStatus } from "../../utils/enums/AuthorizationStatus";
import { requireAuthorization, setError } from "../actions/appActions";

type InitialState = {
  authorizationStatus: AuthorizationStatus;
  error: string | null;
};

const initialState: InitialState = {
  authorizationStatus: AuthorizationStatus.Unknown,
  error: null,
};

export const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(requireAuthorization, (state, action) => {
      state.authorizationStatus = action.payload;
    })
    .addCase(setError, (state, action) => {
      state.error = action.payload;
    });
});
